module.exports = __webpack_public_path__ + "img/no-genre.209249a5.jpg";